import { Icon, Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import ContactCell from '../components/ContactCell';

export default function ResponseTimeTableRowSingle({ row }) {
  const { id, operation, property_type, contact, location, response_time } =
    row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          id={contact?.id}
          cellphone={contact?.cellphone}
          name={contact?.name}
          email={contact?.email}
          image={contact?.image}
          leadStatus={contact?.lead_status}
          agent={contact?.agent || null}
          relativeSelector="#response-time-modal"
          modal="responseTime"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {operation ? (
          <Text variant="body.fontSize13">{operation}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {property_type ? (
          <Text variant="body.fontSize13">{property_type}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {location ? (
          <Text variant="body.fontSize13">{location}</Text>
        ) : (
          <Icon icon="icon-mostrarmenos" />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{response_time}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
